import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Coding from './types/Coding';

export default class BN_ClaimProfilePOSOverrideItem extends BackboneElement {
    static __className = 'BN_ClaimProfilePOSOverrideItem';

    __objectStructure = {
        from: Coding,
        to: Coding,
    };

    constructor(constructJson, className = 'BN_ClaimProfilePOSOverrideItem') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
